import { GetExtranetOrderTicketGroupQueryDto } from '@pharmac-extranet/extranet-api'
import { cleanQueryParams } from '../../../features/infinite-query/util/cleanQueryParams'

export const mapOrderTicketParamsToQueryParams = (
  searchParams: URLSearchParams
): GetExtranetOrderTicketGroupQueryDto => {
  const parsedParams = {
    startDeadlineRange: searchParams.get('startDeadlineRange') ?? undefined,
    endDeadlineRange: searchParams.get('endDeadlineRange') ?? undefined,
    wholeName: searchParams.get('wholeName') ?? undefined,
  }

  return cleanQueryParams(parsedParams)
}
